var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('acgn-statics-staff',{attrs:{"type":2,"routeType":1,"isExternal":true,"exportCode":"6005"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }